import { Dispatch } from "@reduxjs/toolkit";
import { apiDelete, apiGet, apiPost, apiPut } from "./generic.api";
import { UserType } from "../../redux/reducers/settingsReducer";
import { FontSizeType } from "../../components/atoms/FontSizeSelect/FontSizeSelect";
import { ThemeType } from "../../components/atoms/ThemeSelect/ThemeSelect";
import { UserCreationType } from "../../components/organisms/FirstLoginForm/FirstLoginForm";

export const getMe = async (dispatch: Dispatch): Promise<UserType> => {
  const response = await apiGet<{ result: UserType }>(dispatch, `api/user/me`);

  return response.result;
};

export const createUser = async (
  dispatch: Dispatch,
  body: UserCreationType
): Promise<any> => {
  const response = await apiPost<{ data: any }, {}>(
    dispatch,
    `api/user/createUser`,
    body
  );

  return response;
};

export const firstLogin = async (
  dispatch: Dispatch,
  doctorType: string
): Promise<any> => {
  const body = {
    type: doctorType,
  };
  const response = await apiPost<{ data: any }, {}>(
    dispatch,
    `api/user/firstLogin`,
    body
  );

  return response;
};

export const deleteUser = async (dispatch: Dispatch): Promise<any> => {
  const response = await apiDelete<{ data: any }, {}>(
    dispatch,
    `api/user/deleteUser`
  );

  return response;
};

export const revertUser = async (dispatch: Dispatch): Promise<any> => {
  const response = await apiPost<{ data: any }, {}>(
    dispatch,
    `api/user/revertUser`
  );

  return response;
};

export const updateUser = async (
  dispatch: Dispatch,
  name: string
): Promise<any> => {
  const body = {
    name: name,
  };
  const response = await apiPut<{ data: any }, {}>(
    dispatch,
    `api/user/updateUser`,
    body
  );

  return response;
};

export const getAllUserDataForTemplate = async (
  dispatch: Dispatch
): Promise<any> => {
  const response = await apiGet<{ data: any }>(
    dispatch,
    `api/user/getAllUserData`
  );

  return response;
};

export const uploadTemplate = async (
  dispatch: Dispatch,
  file: File
): Promise<any> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiPost<{ data: any }, {}>(
    dispatch,
    `api/user/uploadTemplate`,
    formData
  );

  return response;
};

export const updateUserSettings = async (
  dispatch: Dispatch,
  theme?: ThemeType,
  fontSize?: FontSizeType,
  lang?: string
): Promise<any> => {
  const body = {
    theme: theme,
    fontSize: fontSize,
    lang: lang,
  };
  const response = await apiPut<{ data: any }, {}>(
    dispatch,
    `api/user/updateUserSettings`,
    body
  );

  return response;
};
